module.exports = __webpack_public_path__ + "img/icons-sort-asc.af62bd01.svg";